import { render, staticRenderFns } from "./AdsetWidget.vue?vue&type=template&id=514ca082&"
import script from "./AdsetWidget.vue?vue&type=script&lang=js&"
export * from "./AdsetWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports